import { createContext } from "react";

const ConfirmContext = createContext();

export default ConfirmContext;